// Site getters
const getters = {
  // Have to do some magic coz <3 IE
  sitesArray: state => Object.keys(state.sites).map(key => state.sites[key]),

  sitesSimple: state => Object.keys(state.sites).map(key => {
    return {
      label: state.sites[key].name + ' (' + state.sites[key].id + ')',
      value: state.sites[key].slug,
      hide: !!state.sites[key].deleted_at
    }
  }),

  newSite: ({ newSite }) => newSite,

  active: ({ active }) => active,

  allSites: ({ allSites }) => allSites
}

export default getters
